type ParseUrlObjectType = {
    href: string;
    protocol: string;
    hostname: string;
    port: string;
    pathname: string;
    search: string;
    hash: string;
};

/**
 * Return object link with link data
 * @param {string} href - url
 * @returns {ParseUrlObjectType} - data of link
 */
export const parseUrl = (href = ''): ParseUrlObjectType => {
    const result = {
        href: '',
        protocol: '',
        hostname: '',
        port: '',
        pathname: '',
        search: '',
        hash: '',
    };

    const url = document.createElement('a');
    url.href = href;

    return href
        ? {
              href: url.href,
              protocol: url.protocol,
              hostname: url.hostname,
              port: url.port,
              pathname: url.pathname,
              search: url.search,
              hash: url.hash,
          }
        : result;
};
